//分页配置
enum PaginationEnum {
  PAGE_SIZE = 10,
}

export default PaginationEnum;
